export interface GuideDocument {
  name: string | undefined;
  path: string;
}

/**
 * Resolves the downloadable platform/process guideline documents placed under
 * `public/`. Kept in its own module (separate from `index.tsx`) because it
 * relies on Vite's build-time `import.meta.glob`, which Jest/Babel cannot
 * parse when it lives inline inside a component file that also needs to be
 * unit tested.
 */
export const loadGuideDocument = (): GuideDocument[] => {
  const platformGuidelineFile = import.meta.glob([
    "/public/Procedure Management Platform Guideline*.*",
  ]);
  const processGuidelineFile = import.meta.glob([
    "/public/Procedure Management Process Guideline*.*",
  ]);

  const platformPath = Object.keys(platformGuidelineFile)[0];
  const processPath = Object.keys(processGuidelineFile)[0];

  return [
    {
      name: platformPath.split("/").pop(),
      path: platformPath.replace("/public", ""),
    },
    {
      name: processPath.split("/").pop(),
      path: processPath.replace("/public", ""),
    },
  ];
};
